import React from 'react';
import { useSelector } from 'react-redux';

import { GlobalDataLoader } from 'src/components/GlobalDataLoader';
import { requestSelectors } from 'src/store/requests/selectors';
import {
  useAppOpenModalBookModal,
  useCheckInitialLoadData,
  useIsMobile,
  useBuildType,
} from 'src/hooks';
import { AppMenu } from 'src/components/AppMenu';
import { AppBottomMenu } from 'src/components/AppBottomMenu';
import { ModalBookNow } from 'src/components/modals/BookNow';
import { PolygonsSwitch } from 'src/components/ViewSpinner/components/PolygonsSwitch';
import { useComplex } from 'src/hooks/app/use-complex';
import { IAppFullScreenContainer } from './types';
import { useStyles } from './styles';

export const AppFullScreenContainer: React.FC<IAppFullScreenContainer> = ({
  wrapperClass,
  defaultPageStyles = false,
  children,
  showSwitcher = false,
}) => {
  const { isMobileScreen } = useIsMobile();
  const styles = useStyles({ isMobileScreen });
  const userDataIsLoading: boolean = useSelector(requestSelectors.user.getUserLoading);
  const { isErrors, isLoading } = useCheckInitialLoadData();
  const { isOpen, handleToggleModal } = useAppOpenModalBookModal();
  const { isCrossTable } = useBuildType();
  const { complex } = useComplex();

  if (isErrors || isLoading || (isCrossTable && userDataIsLoading)) {
    return <GlobalDataLoader />;
  }

  return (
    <>
      <AppMenu />
      <div
        id="page-wrap"
        className={`${styles.fullScreenContainer} ${
          defaultPageStyles ? styles.defaultInnerPageStyles : ''
        } ${wrapperClass}`}
      >
        {children}
        { isMobileScreen && <AppBottomMenu /> }
      </div>
      {isOpen && (
        <ModalBookNow
          isOpen={isOpen}
          onClose={handleToggleModal}
          complex={complex}
        />
      )}
      { !isCrossTable && showSwitcher && <div className={styles.polygonsSwitch}><PolygonsSwitch /></div> }
    </>
  );
};
